import React, { useMemo } from "react";

import { Alert } from "@performyard/py-components";

import { WizardSubjectSelection } from "../../../../../../components/WizardSubjectSelection";

import type { CycleType } from "../../Config";
import { SUBJECTS_STEP_ID, SUBJECTS_STEP_TITLE } from "./constants";

type SelectSubjectsStepProps = {
	stepTitle: string;
	cycleType: CycleType;
	groupId: string | null;
	userSelectionId: string | null;
	onSelectionCreated: (id: string) => void;
	showSelectionError: boolean;
};

const MUTATION_FILTERS = { canAssignReviewsTo: true };

export const SelectSubjectsStep = ({
	stepTitle,
	cycleType,
	groupId,
	userSelectionId,
	onSelectionCreated,
	showSelectionError,
}: SelectSubjectsStepProps) => {
	const isGroupCycle = cycleType === "group";

	const filters: Record<string, string | string[]> = useMemo(() => {
		const base: Record<string, string | string[]> = { canAssignReviewsTo: "true" };
		if (isGroupCycle && groupId) {
			base.groupID = groupId;
			base.membershipType = "member";
		}
		return base;
	}, [isGroupCycle, groupId]);

	return (
		<WizardSubjectSelection
			stepTitle={stepTitle}
			subtitle={SUBJECTS_STEP_TITLE}
			stepId={SUBJECTS_STEP_ID}
			userSelectionId={userSelectionId}
			onSelectionCreated={onSelectionCreated}
			error={
				showSelectionError ? (
					<Alert type="error" message="At least one subject must be selected to continue." />
				) : null
			}
			filters={filters}
			mutationFilters={MUTATION_FILTERS}
			showGroupsButton={!isGroupCycle}
		/>
	);
};
